import { queryOptions, useQuery } from "@tanstack/react-query";

import { sessionApi } from "@/lib/session-api";
import type { AccountInfo } from "@blueskydataplatform/shared-ui/types/account.types";

const ACCOUNT_INFO_PATH = "/account/info";

/** Returns the console account, or `null` when the visitor is anonymous (HTTP 401). Never throws on 401. */
export const getSession = async (): Promise<AccountInfo | null> => {
  const res = await sessionApi.get<AccountInfo>(ACCOUNT_INFO_PATH);
  if (res.status === 401) return null;
  return res.data ?? null;
};

export const sessionQueryOptions = () =>
  queryOptions({
    queryKey: ["auth", "session"],
    queryFn: getSession,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

/** `data` is `undefined` while loading, `null` when anonymous, the account when signed in. */
export const useSession = () => useQuery(sessionQueryOptions());
